/**
 * Press Mentions Block.
 * 
 */

/**
 * Press Mentions Crawl.
 * Mobile: Automatic horizontal crawl of logos.
 * Desktop: Automatic horizontal crawl of logos.
 */

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

let
	tl,
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	crawlerBreakpoint = 1024;		// Logo margin-right changes at breakpoint(desktop).

function initSlider() {
	console.log("PRESS MENTIONS: initSlider()");
	let
		$logosContainer = $('.press-mentions__logos'),		// Logos container.
		$logos = $('.press-mentions__logo'),					// Individual logos.
		logosW = 0,
		windowW = $window.width(),
		// logosW = $logosContainer.width(),					// Width of container (window width).
		startX = 0,
		endX = 0;

	$logos.each(function(){
		logosW += $(this).width() + parseInt($(this).css('marginRight'), 10);
	});
	endX = -logosW/2;

	tl = gsap.timeline({
		repeat:-1,
		scrollTrigger: {
			trigger: $logosContainer,
			start: "top bottom",
			end: "bottom top",
			id: "logos",
			// markers: true,
		}
	});

	gsap.set($logosContainer, {x:endX});
	tl.from($logosContainer, {duration:20, x:startX, ease:"none"});
}

function initResizeWatcher() {
	console.log('PRESS MENTIONS: initResizeWatcher()');
	$window.on('resize', function() {
		currWindowW = $window.width();
		console.log('PRESS MENTIONS: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= crawlerBreakpoint) && (prevWindowW < crawlerBreakpoint)) {
			// Kill timeline and re-initialize.
			tl.kill();
			initSlider();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < crawlerBreakpoint) && (prevWindowW >= crawlerBreakpoint)) {
			// Kill timeline and re-initialize.
			tl.kill();
			initSlider();
		}
		prevWindowW = $window.width();
	});
}

exports.init = function () {
    // Run init methods...
	initSlider();
	initResizeWatcher();

    $(document).ready(function() {				// Wait for page load to measure logos.
	    // initSlider();
    });
};